'use client'

import { useTranslations } from 'next-intl'
import Image from 'next/image'
import { useCallback } from 'react'

interface CommitmentCategoryProps {
  id: string
  imageSrc: string
  alt: string
  onClick: (id: string) => void
}

const CommitmentCategory = ({
  id,
  imageSrc,
  alt,
  onClick,
}: CommitmentCategoryProps) => {
  return (
    <div id={id} className='cursor-pointer' onClick={() => onClick(id)}>
      <Image
        src={imageSrc}
        className='w-full rounded-xl'
        width={400}
        height={300}
        alt={alt}
      />
    </div>
  )
}

export default function CommitmentCategories() {
  const t = useTranslations('page_cam_ket_phat_trien')
  const scrollToSection = useCallback((id: string) => {
    const element = document.getElementById(`${id}-content`)
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }, [])

  const categories = [
    {
      id: 'item-1',
      imageSrc: 'https://media.coolmate.me/image/October2024/mceclip2_3.png',
      alt: t('categories.item_1_alt'),
    },
    {
      id: 'item-2',
      imageSrc: 'https://media.coolmate.me/image/November2024/mceclip4_85.png',
      alt: t('categories.item_2_alt'),
    },
    {
      id: 'item-3',
      imageSrc: 'https://media.coolmate.me/image/November2024/mceclip6_7.png',
      alt: t('categories.item_3_alt'),
    },
    {
      id: 'item-4',
      imageSrc: 'https://media.coolmate.me/image/November2024/mceclip7_80.png',
      alt: t('categories.item_4_alt'),
    },
    {
      id: 'item-5',
      imageSrc: 'https://media.coolmate.me/image/November2024/mceclip5_96.png',
      alt: t('categories.item_5_alt'),
    },
  ]

  return (
    <section className="bg-black bg-[url('https://media.coolmate.me/image/October2024/mceclip3_36.png')] bg-cover bg-bottom bg-no-repeat px-4 pb-44 pt-12 md:bg-[url('https://media.coolmate.me/image/October2024/mceclip8_100.png')] md:pt-32">
      <div className='mx-auto grid max-w-[1458px] grid-cols-1 gap-5 md:grid-cols-3'>
        <div className='mb-8 mt-12 text-lg font-medium text-white md:my-0 md:max-w-[486px] md:text-4xl'>
          {t('categories.title')}
        </div>
        {categories.map((category) => (
          <CommitmentCategory
            key={category.id}
            id={category.id}
            imageSrc={category.imageSrc}
            alt={category.alt}
            onClick={scrollToSection}
          />
        ))}
      </div>
    </section>
  )
}
